export const isErrorMethod = (type, activeErrorItem, data, dataIndex) => {
    if (activeErrorItem != {} && activeErrorItem.messageItem != undefined) {
        let lastIndex = activeErrorItem.messageItem.SUB_GRP.length
        let activeErrorSubjectCodes = activeErrorItem.messageItem.SUB_GRP.slice(2, lastIndex)
        let activeErrorGradeCodes = activeErrorItem.messageItem.SUB_GRP[0]
        let activeErrorGroupCodes = activeErrorItem.messageItem.SUB_GRP[1]
        let subCode = activeErrorItem.messageItem.SUB_GRP[dataIndex]

        switch (type) {
            case 'subject':
                if (data != undefined && data.subject != undefined) {
                    if (activeErrorSubjectCodes.length > 0) {
                        if (subCode != undefined && subCode.toLowerCase() == data.subject.code.toLowerCase()) {
                            if (data.group != undefined && activeErrorGroupCodes != undefined && activeErrorGroupCodes.length > 0) {
                                if (activeErrorGroupCodes.find((activeErrorGroupCode) =>
                                    activeErrorGroupCode.toLowerCase() == (data.grade + data.group).toLowerCase()) != undefined) {
                                    return true
                                }
                            }
                            else if (data.grade != undefined && activeErrorGradeCodes != undefined && activeErrorGradeCodes.length > 0) {
                                if (activeErrorGradeCodes.find((activeErrorGradeCode) => activeErrorGradeCode.toLowerCase() == data.grade.toLowerCase()) != undefined) {
                                    return true
                                }
                            }
                        }
                    }
                }
                break;
            case 'elective-name':
                
                if (data != undefined && data.elective != undefined) {
                    if (activeErrorSubjectCodes[0] !== undefined) {

                        if (data.group != undefined && activeErrorGroupCodes != undefined && activeErrorGroupCodes.length > 0) {
                            if (activeErrorGroupCodes.find((activeErrorGroupCode) =>
                                activeErrorGroupCode.toLowerCase() == (data.grade + data.group).toLowerCase()) != undefined) {
                                return true
                            }
                        }
                        else if (data.grade != undefined && activeErrorGradeCodes != undefined && activeErrorGradeCodes.length > 0) {
                            if (activeErrorGradeCodes.find((activeErrorGradeCode) => activeErrorGradeCode.toLowerCase() == data.grade.toLowerCase()) != undefined) {
                                return true
                            }
                        }
                    }
                }
                break;
            case 'elective':
                if (data !== undefined && data.elective !== undefined && activeErrorSubjectCodes[0] !== undefined && data.elective.name.toLowerCase() == activeErrorSubjectCodes[0].toLowerCase()) {
                    if (activeErrorSubjectCodes.length > 0) {
                        if (subCode != undefined && subCode.toLowerCase() == data.subjectCode.toLowerCase()) {
                            if (data.group != undefined && activeErrorGroupCodes != undefined && activeErrorGroupCodes.length > 0) {
                                if (activeErrorGroupCodes.find((activeErrorGroupCode) =>
                                    activeErrorGroupCode.toLowerCase() == (data.grade + data.group).toLowerCase()) != undefined) {
                                    return true
                                }
                            }
                            else if (data.grade != undefined && activeErrorGradeCodes != undefined && activeErrorGradeCodes.length > 0) {
                                if (activeErrorGradeCodes.find((activeErrorGradeCode) => activeErrorGradeCode.toLowerCase() == data.grade.toLowerCase()) != undefined) {
                                    return true
                                }
                            }
                        }
                    }
                }
                break;
            case 'grade': if (activeErrorSubjectCodes.length == 0) {

                if (data.gradeName != undefined && activeErrorGradeCodes.length > 0) {

                    if (activeErrorGradeCodes.find((activeErrorGradeCode) => activeErrorGradeCode.toLowerCase() == data.gradeName.toLowerCase()) != undefined) {
                        return true
                    }
                }
            } break;
            case 'group': if (activeErrorSubjectCodes.length == 0) {

                if (data != undefined && activeErrorGroupCodes.length > 0) {
                    if (activeErrorGroupCodes.find((activeErrorGroupCode) =>
                        activeErrorGroupCode.toLowerCase() == data.toLowerCase()) != undefined) {
                        return true
                    }
                }
            } break;
            default: return false; break;
        }
    }
    return false
}